const ENSIGHTEN_NAME_MAP = {
    da: 'DirectApp',
    px: 'Prox',
    he: 'HermesButton',
    te: 'Tesla'
};

const triggerEnsightenEvent = (
    eventName = 'UKNOWN',
    flow = window.flow || '',
    isSecondButton = window.businessCaseVariation === 'SECOND_BUTTON'
) => {
    let flowName = ENSIGHTEN_NAME_MAP[flow] || 'UKNOWN';
    if (flow === 'he') {
        flowName += isSecondButton ? '2' : '1';
    }
    const ensightenEvent = `CreditApp-${flowName}-${eventName}`;
    if (
        window.Bootstrapper &&
        window.Bootstrapper.ensEvent &&
        window.Bootstrapper.ensEvent.trigger &&
        typeof window.Bootstrapper.ensEvent.trigger === 'function'
    ) {
        window.Bootstrapper.ensEvent.trigger(ensightenEvent);
    }
    window.ensighten = window.ensighten || {};
    window.ensighten.creditDataTrack = ensightenEvent;
    window.capeLog && window.capeLog(`Ensighten Tracking Event: ${ensightenEvent}`);
    return ensightenEvent;
};

export default triggerEnsightenEvent;
